import { sagaCreator } from '@adrias-online/steiner';

import { createSagas } from '../../../helpers/portaleModuleHelper';
import { actions, actionTypes } from '../actions/portaliIndicatori';
import { selectors, DEFAULT_STATE } from '../reducers/portaliIndicatori';
import api from '../apis/portaliIndicatori';

const sagas = createSagas(
    'portaliIndicatori',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        resourceLabel: 'Indicatori'
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
